import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { Grid } from "@material-ui/core";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import List from "@material-ui/core/List";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";
import Track from "./Track";
import {
  makeBackendAPIRequest,
  backendBaseURL,
} from "../api_utilities/backend";
import {
  makeSpotifyAPIRequest,
  getAlbumArtURLFromImages,
} from "../api_utilities/spotify";
import CircularProgress from "@material-ui/core/CircularProgress";

const useStyles = (theme) => ({
  root: {
    width: "100%",
    boxShadow:
      "0px 2px 1px -1px rgba(0,0,0,0.5), 0px 1px 1px 0px rgba(0,0,0,0.38), 0px 1px 3px 0px rgba(0,0,0,0.34)",
  },
  ratingComplete: {
    "& .MuiRating-iconFilled": {
      color: theme.palette.primary.dark,
    },
  },
  ratingIncomplete: {
    "& .MuiRating-iconFilled": {
      color: theme.palette.action.selected,
    },
    "& .MuiRating-iconEmpty": {
      color: theme.palette.action.hover,
    },
  },
  spanning: {
    width: "100%",
  },
  cover: {
    width: "100%",
    height: "100%",
    backgroundSize: "contain",
    opacity: 0.85,
  },
});

class TagAccordion extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isOpen: false, tracks: [] };
  }

  openOrCloseAccordion = () => {
    const { tagInfo } = this.props;
    const { isOpen, tracks } = this.state;

    this.setState((prevState) => {
      return {
        isOpen: !prevState.isOpen,
      };
    });

    if (!isOpen && tracks.length === 0) {
      const url = new URL(backendBaseURL + "/song/get_all_songs_for_tag");
      url.searchParams.append("tag_name", tagInfo.tagName);
      makeBackendAPIRequest({
        url: url,
        method: "GET",
        onSuccessCallback: (data) => {
          const tracks = data.songs;
          const trackGroups = [];
          while (tracks.length > 0) {
            trackGroups.push(tracks.splice(0, 50));
          }

          const promises = trackGroups.map((trackGroup) => {
            const tracksURL = new URL("https://api.spotify.com/v1/tracks");
            tracksURL.searchParams.append(
              "ids",
              trackGroup
                .map((track) => {
                  return track.id_spotify;
                })
                .join(",")
            );
            return makeSpotifyAPIRequest({
              url: tracksURL,
              method: "GET",
              returnPromise: true,
            });
          });

          Promise.all(promises).then((spotifyTrackGroups) => {
            const fullTrackGroups = spotifyTrackGroups.map(
              (spotifyTrackGroup, groupIndex) => {
                const spotifyTracks = spotifyTrackGroup.tracks;
                return spotifyTracks.map((spotifyTrack, trackIndex) => {
                  const spotifyAlbum = spotifyTrack.album;

                  return {
                    albumArtists: spotifyAlbum.artists
                      .map((artist) => artist.name)
                      .join(", "),
                    albumArtURL: getAlbumArtURLFromImages(spotifyAlbum.images),
                    albumID: spotifyAlbum.id,
                    albumName: spotifyAlbum.name,
                    albumTotalTracks: spotifyAlbum.total_tracks,
                    artistName: spotifyTrack.artists
                      .map((artist) => artist.name)
                      .join(", "),
                    rating: trackGroups[groupIndex][trackIndex].rating,
                    releaseYear: new Date(
                      spotifyAlbum.release_date
                    ).getFullYear(),
                    tags: trackGroups[groupIndex][trackIndex].tags,
                    trackID: spotifyTrack.id,
                    trackName: spotifyTrack.name,
                    trackIndex: trackIndex,
                    trackLength: spotifyTrack.track_length,
                    trackNumber: spotifyTrack.track_number,
                  };
                });
              }
            );

            this.setState({ tracks: fullTrackGroups.flat() });
          });
        },
      });
    }
  };

  render() {
    const { classes, tagInfo, store } = this.props;

    const { isOpen, tracks } = this.state;

    return (
      <Accordion
        className={classes.root}
        expanded={isOpen}
        onChange={this.openOrCloseAccordion}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Grid container>
            <Grid container item xs={12} justify={"space-between"} spacing={1}>
              <Grid container item xs={1} justify="center" direction="column">
                <LocalOfferIcon color="primary" fontSize="large" />
              </Grid>
              <Grid container item xs={11} justify="center" direction="column">
                <Typography variant={"h6"} color={"textSecondary"}>
                  {tagInfo.tagName}
                </Typography>
                <Typography variant={"caption"} color={"textSecondary"}>
                  count: {tagInfo.tagCount}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </AccordionSummary>
        <AccordionDetails>
          {tracks.length === 0 ? (
            <Grid container item xs={12} justify="center">
              <CircularProgress />
            </Grid>
          ) : (
            <List className={classes.spanning}>
              {tracks.map((track, i) => (
                <Track
                  key={track.trackID}
                  trackAndAlbumInfo={{
                    albumArtists: track.albumArtists,
                    albumArtURL: track.albumArtURL,
                    albumID: track.albumID,
                    albumIndex: null,
                    albumName: track.albumName,
                    albumTotalTracks: track.albumTotalTracks,
                    artistName: track.artistName,
                    rating: track.rating,
                    releaseYear: track.releaseYear,
                    tags: track.tags,
                    trackID: track.trackID,
                    trackName: track.trackName,
                    trackIndex: track.trackIndex,
                  }}
                  onTagsUpdatedOptimistic={() => {}}
                  onTrackRated={() => {}}
                  store={store}
                  trackIDsAfter={tracks
                    .slice(i + 1)
                    .map((track) => track.trackID)}
                  tabIndex={i + 1}
                />
              ))}
            </List>
          )}
        </AccordionDetails>
      </Accordion>
    );
  }
}

export default withStyles(useStyles)(TagAccordion);
